import(/* webpackMode: "eager" */ "/root/tekyerde-frontend/app/(commerce)/hakkimizda/page.tsx");
